import { useCallback, useEffect, useRef, useState } from "react";
import { Asset } from "../../types/asset";
import { Galleria, GalleriaItemChangeEvent } from "primereact/galleria";
import { ImagesGalleryItem } from "./ImageGalleryItem";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectViewImages } from "../../store/selectors/inspectionSelectors";
import { setViewImages } from "../../store/slices/inspectionSlice";

export const ImagesGalleria = () => {
    const dispatch = useAppDispatch();
    const images = useAppSelector(selectViewImages);

    // Galleria needs something to be mounted due to primereact logic:
    // return ObjectUtils.isNotEmpty(props.value) && createGalleria();
    const [value, setValue] = useState<(Asset | string)[]>([""]);
    const [activeIndex, setActiveIndex] = useState(0);

    const ref = useRef<Galleria>(null);

    useEffect(() => {
        if (images.length && ref.current) {
            setValue(images);
            ref.current?.show();
        }
    }, [images]);

    const itemTemplate = useCallback(
        (image: Asset) => (
            <ImagesGalleryItem
                className="col-10"
                checked={false}
                image={image}
            />
        ),
        [images]
    );

    const onItemChange = useCallback(
        (event: GalleriaItemChangeEvent) => setActiveIndex(event.index),
        []
    );

    const onHide = useCallback(() => {
        dispatch(setViewImages([]));
        setValue([""]);
        setActiveIndex(0);
    }, []);

    return (
        <Galleria
            ref={ref}
            fullScreen
            showIndicators
            activeIndex={activeIndex}
            value={value}
            showThumbnails={false}
            showItemNavigators={value.length > 1}
            item={itemTemplate}
            onItemChange={onItemChange}
            onHide={onHide}
        />
    );
};
